class Configuration
{
    constructor()
    {
        this.base = "http://developers.nsru.ac.th/histories/P11_NSRU/2017";
    }
}

export default Configuration;
